import { calender } from 'mostra';
const {
  toDate,
} = calender;
export {
  calender,
  toDate,
};

// import * as firebase from 'firebase/app';
// import 'firebase/firestore';
// import moment from 'moment';
// import 'moment-timezone';
// import _ from 'lodash';
//
// import { FirestoreDate } from '@/modules/firestore';
//
// export const toDate = (date: FirestoreDate): Date => {
//   if (!date) return new Date();
//   // if (typeof date === typeof firebase.firestore.Timestamp) {
//   if ((date as firebase.firestore.Timestamp).toDate) {
//     return (date as firebase.firestore.Timestamp).toDate();
//   }
//   return date as Date;
// };
//
// export const formatDate = (date: FirestoreDate | null): string => {
//   if (date) {
//     const dt = toDate(date);
//     return moment(dt)
//       .tz('Asia/Tokyo')
//       .format('YYYY/MM/DD');
//   }
//   return '';
// };
//
// export const formatDateJP = (date: FirestoreDate | null): string => {
//   if (date) {
//     const dt = toDate(date);
//     return moment(dt)
//       .tz('Asia/Tokyo')
//       .format('YYYY[年]MM[月]DD[日]');
//   }
//   return '';
// };
//
// export const formatDateJP2 = (date: FirestoreDate | null): string => {
//   if (date) {
//     const dt = toDate(date);
//     return moment(dt)
//       .tz('Asia/Tokyo')
//       .locale('ja')
//       .format('MMMDo(ddd)');
//   }
//   return '';
// };
//
// export const formatDateGMT = (date: FirestoreDate | null): string => {
//   if (date) {
//     const dt = toDate(date);
//     dt.setHours(dt.getHours() + 9);
//     return dt.toUTCString();
//   }
//   return '';
// };
//
// export const formatDateTime = (date: FirestoreDate | null): string => {
//   if (date) {
//     const dt = toDate(date);
//     return moment(dt)
//       .tz('Asia/Tokyo')
//       .format('YYYY/MM/DD HH:mm:ss');
//   }
//   return '';
// };
//
// export const formatYearMonth = (date: FirestoreDate | null): string => {
//   if (date) {
//     const dt = toDate(date);
//     return moment(dt)
//       .tz('Asia/Tokyo')
//       .format('YYYY/MM');
//   }
//   return '';
// };
//
// export const formatDay = (date: FirestoreDate | null): string => {
//   if (date) {
//     const dt = toDate(date);
//     return moment(dt)
//       .tz('Asia/Tokyo')
//       .locale('ja')
//       .format('[(]ddd[)]');
//   }
//   return '';
// };
//
// export const formatHourMinute = (date: FirestoreDate | null): string => {
//   if (date) {
//     const dt = toDate(date);
//     return moment(dt)
//       .tz('Asia/Tokyo')
//       .format('HH:mm');
//   }
//   return '';
// };
//
// export const formatNumberToString = (time: number | null): string => {
//   if (time || time === 0) {
//     const padTime = (n: number): string => _.padStart(`${n}`, 2, '0');
//     const dt = `${Math.floor(time / 100)}:${padTime(time % 100)}`;
//     return dt;
//   }
//   return '-:--';
// };
//
// export const formatContactListDate = (date: FirestoreDate | null): string => {
//   if (date) {
//     const currentDt = new Date();
//     const currentDate = moment(currentDt).tz('Asia/Tokyo').format('YYYY/MM/DD');
//     const contactDate = formatDate(date);
//     if (currentDate === contactDate) {
//       return formatHourMinute(date);
//     }
//     const contactDt = toDate(date);
//     return moment(contactDt)
//       .tz('Asia/Tokyo')
//       .format('YYYY/MM/DD HH:mm');
//   }
//   return '';
// };
//
// export default formatDate;
// export const isAfterDate = (checkDate: FirestoreDate | null, comparedDate: FirestoreDate | null): boolean => {
//   if (checkDate && comparedDate) {
//     const check = toDate(checkDate);
//     const compared = toDate(comparedDate);
//     return moment(check).isAfter(compared);
//   }
//   return false;
// };
//
// export default formatDate;
